const taskTemplates = require('../../task-templates');

const tasksData = [
	/* case 1 */
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'sales-mc-prices-1',
		text: `I skal fastsætte jeres priser, så I tjener flest muligt penge til Future Business A/S.
			<br /><br /><b>Hvilke tre ting er vigtigst at have fokus på</b>, når I bestemmer priserne på varerne?`,
		hintText: `De rigtige svar handler om markedet, omkostningerne og kundernes betalingsevne.`,
		popupText: `På HHX arbejder man med prissætning ud fra både konkurrence, omkostninger og kundernes økonomi – <b>ligesom virksomheder gør i virkeligheden.</b>`,
		image: 'hhx-sales-pricing',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Konkurrentens priser', 
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Virksomhedens udgifter',
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Kundernes rådighedsbeløb',
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'Jeres private udgifter',
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 2,
		title: 'Opgave 2A',
		taskId: 'sales-mc-prices-2a',
		text: `Future Business A/S har et populært produkt, som mange kunder efterspørger.
			<br /><br />Produktet er af høj kvalitet og har en stærk profil.
			<br /><br /><b>Hvordan vil I fastsætte prisen?</b>`,
		hintText: `Produktet er efterspurgt, har høj kvalitet og en stærk profil – <b>prisen behøver derfor ikke være lav fra start.</b>`,
		popupText: `På HHX arbejder man med prissætning ud fra efterspørgsel og kvalitet.`,
		image: 'hhx-sales-pricing-2',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Start høj og så gradvis lavere', 
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Start lav og så gradvist op'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Start lav og sæt meget op hvis der er efterspørgsel', 
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 2.3,
		lockedById: 'sales-mc-prices-2a',
		taskId: 'sales-mc-prices-2b',
		title: 'Opgave 2B',
		text: `Future Business A/S har også en helt almindelig løsning uden ekstra features.
			<br /><br /><b>Hvordan skal prisen være?</b>`,
		hintText: `Produktet er en standardløsning uden ekstra features – <b>prisen skal derfor være lav i starten.</b>`,
		popupText: null,
		image: 'hhx-sales-pricing-2b',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Start høj og så gradvis lavere', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Start lav og så gradvist op',
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Læg prisen midt imellem fra start', 
			})
		],
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 2.6,
		lockedById: 'sales-mc-prices-2b',
		taskId: 'sales-sort-prices-2c',
		title: 'Opgave 2C',
		text: `Når en virksomhed starter med en høj pris og sænker den over tid, kaldes det <b>skimming price</b>.
			<br /><br />Når en virksomhed starter med en lav pris for at få mange kunder, kaldes det <b>penetration price</b>.
			<br /><br />Snak sammen og sorter sætningerne, så de passer til enten skimming price eller penetration price.`,
		hintText: `<b>Skimming</b> = høj pris først. 
			<br /><br /><b>Penetration</b> = lav pris først.`,
		popupText: `På HHX arbejder man med forskellige prissætningsstrategier.`,
		layout: 'halfdouble-height',
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'skimming', 
				title: `Skimming price`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'penetration', 
				title: `Penetration price`
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, 
				text: `Passer til markeder med mange konkurrenter`,
				categoryIds: ['penetration']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, 
				text: `Passer til kunder der vil have det nyeste nu`,
				categoryIds: ['skimming']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, 
				text: `Giver høj fortjeneste på den korte bane`,
				categoryIds: ['skimming']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, 
				text: `Kan skræmme folk væk når prisen stiger`,
				categoryIds: ['penetration']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 5, 
				text: `Signalerer høj kvalitet`,
				categoryIds: ['skimming']
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 3,
		title: 'Opgave 3',
		taskId: 'sales-mc-prices-3',
		text: `Når I skriver priser til privatkunder, skal prisen så være med eller uden moms?
			<br /><br /><b>I kan kun vælge én.</b>`,
		showNumberOfAnswersToSelect: false,
		hintText: `Privatkunder ser altid priser med moms.`,
		popupText: `På HHX lærer man at skelne mellem priser til privatkunder og virksomheder.`,
		image: 'hhx-sales-pricing-3',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Altid inklusiv', 
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Altid eksklusiv',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Inklusiv i butikken, eksklusiv på web',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'Inklusiv på web, eksklusiv i butikken',
			}),
		],
	}),
	/* case 2 */
	Object.assign({}, taskTemplates.paperDollTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'sales-paper-doll-equipment',
		layout: 'sales-equipment',
		avatarId: 'avatar-2',
		text: `Hvad skal de ansatte huske, når de arbejder med kunder i virksomheden?
			<br /><br />Vælg det, I tror er rigtigt, og tryk OK.`,
		popupTExt: `På HHX arbejder man med, hvordan virksomheder møder og håndterer kunder.`,
		items: [
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'future-business-polo', title: 'Futures Business A/S trøje', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'name-tag2', title: 'Navneskilt'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'phone', title: 'Mobiltelefon', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'pen2', title: 'Kuglepen', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'smile', title: 'Stort smil', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'whistle', title: 'Fløjte'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'shirt-stained', title: 'Plettet skjorte'
			}),
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'sales-mc-customer-service-2',
		text: `En kunde har netop kontaktet Future Business A/S. 
			<br /><br />Hvilken af følgende ting er <b>IKKE</b> vigtig for et godt førstehåndsindtryk?`,
		hintText: `God kundekontakt handler om at lytte – ikke om at overvælde kunden med noget, de ikke har efterspurgt.`,
		popupText: null,
		image: 'hhx-sales-customer-service-2',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'De første 20 sekunder af samtalen', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'At svare hurtigt og venligt'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'At sende en masse løsninger, kunden ikke har bedt om',
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'De første 20 ord du siger'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5,
				text: 'Hvor hurtigt I tager sagen videre til den rigtige person'
			}),
		],
	}),
	Object.assign({}, taskTemplates.spotErrorsTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 3,
		title: 'Opgave 3',
		taskId: 'sales-spot-errors-store',
		layout: 'sales-store',
		text: `Et ryddeligt lager er vigtigt for medarbejdernes arbejde.
			<br /><br />Se om I kan spotte de ting, der gør lageret uoverskueligt og ineffektivt.
			<br /><br /><b>Tryk OK, når I tror, I har fundet dem alle.</b>`,
		errors: [
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'paper-on-floor'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'broken-lamp'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'box-with-knife'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'clothes'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'sales-man'}),
		]
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 4,
		taskId: 'sales-sort-shop-window',
		layout: 'sales-shop-window',
		title: 'Opgave 4',
		text: `En præsentation til kunder og samarbejdspartnere skal se professionel ud.
			<br /><br /><b>Placer materialerne, så præsentationen fremstår overskuelig og indbydende.</b>`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'top-shelf', 
				type: 'image'
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'middle-shelf', 
				type: 'image'
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'bottom-shelf', 
				type: 'image'
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, 
				type: 'image',
				categoryIds: ['top-shelf']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, 
				type: 'image',
				categoryIds: ['top-shelf']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, 
				type: 'image',
				categoryIds: ['top-shelf']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, 
				type: 'image',
				categoryIds: ['middle-shelf']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 5, 
				type: 'image',
				categoryIds: ['middle-shelf']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 6, 
				type: 'image',
				categoryIds: ['middle-shelf']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 7, 
				type: 'image',
				categoryIds: ['bottom-shelf']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 8, 
				type: 'image',
				categoryIds: ['bottom-shelf']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 9, 
				type: 'image',
				categoryIds: ['bottom-shelf']
			})
		]
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 5,
		taskId: 'sales-sort-typical-day',
		title: 'Opgave 5',
		text: `Hvad skal du gøre hvornår på en typisk arbejdsdag i Future Business A/S?
			<br /><br /><b>Træk opgaverne hen i de rigtige kasser.</b>`,
		hintText: `Opgaver med <b>forberedelse</b> ligger før åbning, <b>kundearbejde</b> og <b>opfølgning</b> sker i løbet af dagen, og <b>systemer</b> samt <b>resultater</b> klares efter lukketid.`,
		popupText: `På HHX arbejder man med at strukturere arbejdsdagen i en virksomhed.`,
		layout: 'halfdouble-height',
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'before', 
				title: `Før åbning`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'during', 
				title: `I løbet af dagen`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'closing', 
				title: `Efter lukketid`
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, 
				text: `Opdatere systemer og overblik`,
				categoryIds: ['closing']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, 
				text: `Gennemgå dagens resultater`,
				categoryIds: ['closing']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, 
				text: `Arbejde med kunder eller samarbejdspartnere`,
				categoryIds: ['during']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, 
				text: `Forberede dagens opgaver`,
				categoryIds: ['before']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 5, 
				text: `Følge op på igangværende sager`,
				categoryIds: ['during']
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 6,
		title: 'Opgave 6',
		taskId: 'sales-multiple-choice-question',
		text: `I er midt i en opgave, da en kunde kontakter jer med et spørgsmål. 
			<br /><br /><b>Hvad gør I?</b>`,
		hintText: `<b>God kundeservice</b> handler om, at kunden <b>ikke skal vente</b> unødigt, hvis der er en bedre løsning.`,
		popupText: `På HHX arbejder man med god kundeservice i praksis.`,
		image: 'hhx-sales-customer-service-6',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Sætter kunden på hold til du har tid', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Henviser kunden til en kollega, der har bedre tid'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Stopper din opgave og hjælper kunden med det samme',
				isCorrect: true
			}),
		],
	}),
	/* case 3 */
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'sales-online-sales-1',
		text: `En webshop kræver en stor investering, men I forventer, at overskuddet kan fordobles hvert år.
			<br /><br />Investeringen er <b>1.500.000 kr.</b>, og overskuddet i år er <b>100.000 kr.</b>
			<br /><br /><b>Hvor mange år går der, før investeringen er tjent hjem?</b>`,
		answer: 4,
		unit: 'år.',
		image: null,
		hintText: `<b>Start med årets overskud</b> og <b>fordobl beløbet år for år</b>. 
			<br /><br />Læg hvert års overskud sammen, indtil investeringen er dækket.`,
		popupText: `På HHX arbejder man med investeringer og tilbagebetalingstid.`
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 2,
		taskId: 'sales-online-sales-2',
		title: 'Opgave 2',
		text: `Hvad er <b>jeres bud</b> på, hvad der er vigtigst for, at en webshop bliver en succes?
			<br /><br />Sæt punkterne i rækkefølge fra mest til mindst vigtigt for sidens succes.`,
		text: 'For at lave en succesfuld online hjemmeside som sælger er der mange vigtige ting at tænke på, sorter i rækkefølge hvad I mener er mest vigtigt for salget.',
		hintText: `Fokusér på det, der gør det <b>nemt for kunden at finde, forstå og vælge løsninger</b> – ikke på ekstra effekter.`,
		popupText: `På HHX arbejder man med, hvad der skaber værdi og brugervenlighed for kunder online.`,
		layout: 'halfdouble-height',
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'ui', 
				text: `Hjemmesiden er nem at finde rundt på`,
				correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'products', 
				text: `Hjemmesiden viser tydelige billeder af løsningerne`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'allproducts', 
				text: `Alle løsninger er samlet ét sted`,
				correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'url', 
				text: `Webshoppen har en nem webadresse`,
				correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'picture', 
				text: `Der er lyd og levende billeder på hjemmesiden`,
				correctOrderNumbers: [5]
			})
		]
	}),
	/* case 4 */
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 1,
		taskId: 'sales-distribution-chain-1',
		title: 'Opgave 1',
		text: `Hvordan går en ny idé fra tanke til kunde i Future Business A/S?
			<br /><br /><b>Sæt trinnene i den rigtige rækkefølge.</b>`,
		hintText: `En idé bliver først til noget, når den planlægges, udvikles og kan sælges – før den når ud til kunderne.`,
		popupText: `På HHX arbejder man med, hvordan idéer bliver til produkter og når ud til kunder.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'idea', 
				text: `Idé og planlægning`,
				correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'development', 
				text: `Udvikling af løsningen`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'sales', 
				text: `Salg og distribution`,
				correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'customers', 
				text: `Kunderne`,
				correctOrderNumbers: [4]
			}),
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 2,
		title: 'Opgave 2A',
		taskId: 'sales-distribution-chain-2a',
		text: `Future Business A/S har fået tre tilbud på konsulenttimer i to erfaringsniveauer. Hvert tilbud indeholder 100 timer med høj erfaring og 50 timer med lav erfaring.
			<br />Indkøbspris pr. time:
			<br /><br /><b>Prime Consulting:</b>
			<br />Lav erfaring: 600 kr. // Høj erfaring: 1.200 kr.
			<br /><br /><b>Business Advisors:</b>
			<br />Lav erfaring: 700 kr. // Høj erfaring: 1.000 kr.
			<br /><br /><b>Strategy Partners:</b>
			<br />Lav erfaring: 450 kr. // Høj erfaring: 1.300 kr.
			<br /><br />I kan sælge timer med lav erfaring for 1.400 kr. og timer med høj erfaring for 2.600 kr., og I vil tjene så meget som muligt.
			<br />Hvilket firma skal I vælge, hvis I kun kigger på prisen?`,
		hintText: `Regn <b>først den samlede indkøbspris</b> for 100 timer med høj erfaring og 50 timer med lav erfaring hos hvert firma. 
			<br /><br />Sammenlign derefter, hvilket der giver størst forskel mellem salgspris og indkøbspris.`,
		popupText: `På HHX arbejder man med at sammenligne omkostninger og indtjening for at vælge den bedste løsning.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Prime Consulting', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Business Advisors',
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Strategy Partners',
			}),
		],
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 2.5,
		title: 'Opgave 2B',
		lockedById: 'sales-distribution-chain-2a',
		taskId: 'sales-distribution-chain-2b',
		text: `I vælger <b>Business Advisors.</b>
			<br />I skal købe <b>1.000 timer med lav erfaring</b> og <b>500 timer med høj erfaring</b>.
			<br /><br /><b>Pris pr. time:</b>
			<br />Lav erfaring: 700 kr.
			<br />Høj erfaring: 1.000 kr.
			<br /><br />Hvad bliver den samlede pris?`,
		answer: 1200000,
		unit: 'kr',
		image: 'hhx-sales-distribution-chain-2b',
		hintText: `Regn prisen for de <b>1.000 timer</b> og de <b>500 timer</b> hver for sig, og læg beløbene sammen.`,
		popupText: `Sådan arbejder man med omkostningsberegninger og økonomisk overblik på HHX.`
	}),
	/* case 5 */
	Object.assign({}, taskTemplates.paperDollTemplate.mainTemplate, {
		caseId: 5,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'sales-communication-1',
		layout: 'sales-working-in-marketing',
		avatarId: 'avatar-2',
		text: `Hvad er vigtigt at have med, når man arbejder med online markedsføring og indhold?
			<br /><br /><b>Vælg det, I tror er rigtigt, og tryk OK.</b>`,

		items: [
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'computer', title: 'Computer', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'printer', title: 'Printer'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'tv', title: 'Fjernsyn'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'name-tag2', title: 'Navneskilt'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'tie', title: 'Slips'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'phone', title: 'Smartphone', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'camera', title: 'Kamera', isCorrect: true
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 5,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'sales-communication-2',
		text: `I skal fange opmærksomheden online. 
			<br /><br /><b>Hvad tror I får folk til at stoppe op?</b>`,
		hintText: `Folk stopper op, når indholdet hurtigt giver mening og føles relevant – <b>ikke når det er for langt eller uklart</b>.`,
		popupText: `På HHX arbejder man med målgrupper og effektiv kommunikation online.`,
		image: 'hhx-sales-communication-2',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Indhold med så meget information som muligt', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Indhold med det nyeste og mest relevante',
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Indhold uden tydeligt budskab',
			}),
		],
	}),
	Object.assign({}, taskTemplates.pairsTemplate.mainTemplate, {
		caseId: 5,
		taskNumber: 3,
		title: 'Opgave 3',
		taskId: 'sales-communication-3',
		text: `Målgrupper handler også om at vide, hvor mange der er i en bestemt gruppe.
			<br /><br /><b>Dan par ved at google og matche tallene med den rigtige gruppe.</b>`,
		hintText: `En målgruppe er den type mennesker, virksomheden gerne vil ramme – fx unge, voksne eller familier.`,
		popupText: `På HHX arbejder man med målgrupper og data for at forstå markedets størrelse.`,
		columnAItems: [
			Object.assign({}, taskTemplates.pairsTemplate.itemTemplate, {
				id: '1p1mio',
				text: `1,1 millioner`,
			}),
			Object.assign({}, taskTemplates.pairsTemplate.itemTemplate, {
				id: '28percent',
				text: '28%'
			}),
			Object.assign({}, taskTemplates.pairsTemplate.itemTemplate, {
				id: 'n302000',
				text: `302.000`
			}),
			Object.assign({}, taskTemplates.pairsTemplate.itemTemplate, {
				id: '2p1mio',
				text: '2,1 mio'
			}),
		],
		columnBItems: [
			Object.assign({}, taskTemplates.pairsTemplate.itemTemplate, {
				id: 'state-pensioners',
				text: 'Folkepensionister',
				connectedToItemId: '1p1mio'

			}),
			Object.assign({}, taskTemplates.pairsTemplate.itemTemplate, {
				id: 'vocational-education',
				text: '15-69-årige har gennemført erhversfaglig udd.',
				connectedToItemId: '28percent'
			}),
			Object.assign({}, taskTemplates.pairsTemplate.itemTemplate, {
				id: 'receives-su',
				text: 'Modtager SU',
				connectedToItemId: 'n302000'
			}),
			Object.assign({}, taskTemplates.pairsTemplate.itemTemplate, {
				id: 'married',
				text: 'Har valgt at indgå ægteskab',
				connectedToItemId: '2p1mio'
			})
		]
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 5,
		taskNumber: 4,
		taskId: 'sales-communication-4',
		title: 'Opgave 4',
		text: `Måden virksomheder laver reklame på har ændret sig meget.
			<br /><br />Trykte annoncer fylder langt mindre i dag end tidligere.
			<br /><br /><b>Hvad tror I fylder mest hos reklamebureauer i dag?</b>
			<br /><br />Sæt områderne i rækkefølge fra <b>størst</b> til <b>mindst</b>.`,
		hintText: `Tænk på hvor folk bruger mest tid i hverdagen – og hvor <b>reklamer nemmest kan målrettes og måles</b>.`,
		popupText: `Det her fylder også meget i undervisningen på HHX.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'internet', 
				text: `Internet`,
				correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'ads', 
				text: `Udendørs reklamer`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'tv', 
				text: `TV og streaming`,
				correctOrderNumbers: [3]
			})
		]
	}),

	/* case 6 */
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 6,
		taskNumber: 1,
		taskId: 'sales-social-media-1',
		title: 'Opgave 1',
		text: `Hvilke sociale medier er bedst til at nå de unge? 
			<br /><br />Sæt dem i rækkefølge fra <b>bedst</b> til <b>værst</b>.`,
		hintText: `Tænk på hvilke platforme der bruges mest til markedsføring i dag, og hvor <b>Future Business A/S</b> lettest kan ramme deres kunder.`,
		popupText: `På HHX arbejder man med at vælge sociale medier ud fra målgrupper og forretningsmål – ikke bare hvad man selv bruger.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'tiktok', 
				text: `TikTok`,
				correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'instagram', 
				text: `Instagram`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'facebook', 
				text: `Snapchat`,
				correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'twitter', 
				text: `Facebook`,
				correctOrderNumbers: [4]
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 6,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'sales-social-media-2',
		text: `<b>AIDA-modellen</b> bliver brugt af mange virksomheder.
			<br /><br />Hvad bruges den til?`,
		hintText: `Modellen handler om, hvordan en reklame fanger opmærksomhed, skaber interesse og får kunden til at handle.`,
		popupText: `På HHX arbejder man med modeller som AIDA for at forstå, hvordan markedsføring påvirker kunders beslutninger.`,
		image: 'hhx-sales-social-media-2',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Til at lave den bedst mulige reklame', 
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Til økonomistyring',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Til at finde nye og dygtige ansatte',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'Til at finde svagheder I virksomheden',
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 6,
		taskNumber: 3,
		title: 'Opgave 3',
		taskId: 'sales-social-media-3',
		text: `Hvad står <b>AIDA</b> for?`,
		imageText: `Det kan være en god ide at google det :)`,
		popupText: null,
		image: 'hhx-sales-social-media-3',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Attention, Interest, Desire, Action', 
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Angrib Ikke Din Agenda',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Act, Invest, Dream, Allow',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'Aktiver, Interessenter, Deltagere, Aftaler',
			}),
		],
	}),
];

let taskIdsArr = [];
tasksData.forEach((task, index) => {
	/* Assign unique id used for navigation */
	task.id = 'hhxedu-' + (index + 1 < 10 ? '0' : '') + (index + 1);

	/* Check taskId is set when required and unique */
	if (task.taskId) {
		if (taskIdsArr.indexOf(task.taskId) >= 0) {
			console.error('Task id not unique: ', task.taskId);
		} else {
			taskIdsArr.push(task.taskId);
		}
	} else {
		console.error('Missing task id for task: ', task);
	}
});

export {
	tasksData
};